import { render, staticRenderFns } from "./capture-image.vue?vue&type=template&id=0a70d65e&scoped=true"
import script from "./capture-image.vue?vue&type=script&lang=js"
export * from "./capture-image.vue?vue&type=script&lang=js"
import style0 from "./capture-image.vue?vue&type=style&index=0&id=0a70d65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70d65e",
  null
  
)

export default component.exports